import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	formTitle: 'Заяви безплатна миграция в Superhosting',
	formLabels: {
		name: {
			label: 'име',
			placeholder: 'Иван Иванов'
		},
		domain: {
			label: 'домейн',
			placeholder: 'Уебсайтът, който да преместим'
		},
		email: {
			label: 'имейл'
		},
		phone: {
			label: 'телефон'
		}
	},
	helpText: '* Всички полета са задължителни!',
	buttonText: 'Заявяване на миграция',
	successText: [
		'Заявката е направена.',
		'Наш колега ще се свърже с теб в работни дни от 9:00 до 18:00, за да уточните всички детайли.'
	],
	errorMsg: {
		emptyName: 'Моля, въведете своето име.',
		emptyEmail: 'Моля, уверете се, че сте въвели своят имейл.',
		invalidEmail: 'Моля, въведете валиден имейл.',
		emptyPhoneCode: 'Моля, уверете се, че сте избрали код.',
		emptyPhone: 'Моля, уверете се, че сте попълнили полето за телефон.',
		badPhoneNumber: 'Моля, въведи валиден телефонен номер.',
		emptyDomain: 'Моля, уверете се, че сте попълнили полето за домейн.',
	}
};

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	formTitle: 'Request a free migration to Superhosting',
	formLabels: {
		name: {
			label: 'name',
			placeholder: 'Ivan Ivanov'
		},
		domain: {
			label: 'domain',
			placeholder: 'The website that will be migrated'
		},
		email: {
			label: 'email'
		},
		phone: {
			label: 'phone'
		}
	},
	helpText: '* All fields are required!',
	buttonText: 'Request Migration',
	successText: [
		'The request has been submitted.',
		'Our colleague will contact you on weekdays between 9:00 AM and 6:00 PM to provide clarification regarding the details.'
	],
	errorMsg: {
		emptyName: 'Please enter your name.',
		emptyEmail: 'Please make sure you have entered your email.',
		invalidEmail: 'Please enter a valid email.',
		emptyPhoneCode: 'Please make sure you have selected a code.',
		emptyPhone: 'Please make sure you have filled in the phone field.',
		badPhoneNumber: 'Please enter a valid phone number.',
		emptyDomain: 'Please make sure you have filled in the domain field.',
	}
};

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];
